import { findElements } from './findElements';

export interface FocusTrap {
    enable(): void;
    disable(): void;
}

const EVENT_NAME: string = 'keydown';
const KEY_TAB: string = 'Tab';

export function focusTrap(container: HTMLElement): FocusTrap {
    let elements: HTMLElement[];

    function check(event: KeyboardEvent): void {
        if (event.key !== KEY_TAB) {
            return;
        }

        event.preventDefault();

        if (elements.length === 0) {
            return;
        }

        const offset: number = event.shiftKey ? -1 : 1;
        let index: number = elements.indexOf(
            <HTMLElement>document.activeElement,
        );

        index += offset;

        if (index >= elements.length) {
            index = 0;
        } else if (index < 0) {
            index = elements.length - 1;
        }

        elements[index].focus();
    }

    return {
        enable(): void {
            elements = findElements(container);

            window.addEventListener(EVENT_NAME, check);
        },
        disable(): void {
            window.removeEventListener(EVENT_NAME, check);
        },
    };
}
